import { render, staticRenderFns } from "./ActiveManageView2.vue?vue&type=template&id=b4e4b3ea&scoped=true&"
import script from "./ActiveManageView2.vue?vue&type=script&lang=js&"
export * from "./ActiveManageView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e4b3ea",
  null
  
)

export default component.exports